import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import API from '../services/api';
import logo from '../assets/landinglogo.jpg';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // 'success' | 'error'
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      const res = await API.post('/auth/forgot-password', { email });
      setMessage(res.data.message);
      setStatus('success');
    } catch (err) {
      setMessage(err.response?.data?.message || 'Something went wrong. Please try again.');
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', justifyContent: 'flex-start', alignItems: 'center', background: 'var(--surface-muted)', paddingTop: '4rem' }}>
      <div style={{ background: '#fff', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '2rem', width: '320px', textAlign: 'center', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}>
        <img src={logo} alt="Logo" style={{ width: '175px', marginBottom: '1rem' }} />

        <h2 style={{ marginBottom: '0.5rem', fontSize: '1.2rem' }}>Forgot Password</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: '1.5rem' }}>
          Enter your email and we'll send you a link to reset your password.
        </p>

        {status === 'success' ? (
          <div>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>✉️</div>
            <p style={{ color: 'var(--accent-color)', fontWeight: 600, marginBottom: '0.5rem' }}>Check your email</p>
            <p style={{ color: 'var(--text-strong)', fontSize: '0.9rem', marginBottom: '1.5rem' }}>{message}</p>
            <Link to="/" style={{ color: 'var(--accent-color)', fontSize: '0.9rem' }}>← Back to login</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1rem', textAlign: 'left' }}>
              <label style={{ fontSize: '0.9rem' }}>Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                placeholder="you@example.com"
                style={{ width: '100%', padding: '0.5rem', boxSizing: 'border-box', marginTop: '0.25rem', border: '1px solid var(--border-color)', borderRadius: '4px' }}
              />
            </div>

            {status === 'error' && (
              <p style={{ color: 'var(--error-color)', fontSize: '0.85rem', marginBottom: '0.75rem' }}>{message}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{ width: '100%', padding: '0.75rem', backgroundColor: 'var(--accent-color)', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '1rem', opacity: loading ? 0.7 : 1 }}
            >
              {loading ? 'Sending…' : 'Send Reset Link'}
            </button>

            <div style={{ marginTop: '1rem' }}>
              <Link to="/" style={{ color: 'var(--accent-color)', fontSize: '0.9rem' }}>← Back to login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
